import { Nature, Section } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import RoleDeRecouvrementPanel from '../panel/RoleDeRecouvrementPanel';
import BaseProfilEcritureRecette from './Base/BaseProfilEcritureRecette';

class ProfilEcritureTitreRecapRoleRecette extends BaseProfilEcritureRecette {
	constructor() {
		super();
		this.code = PROFIL_ECRITURE.RECETTE.TITRE_RECAP_ROLE;
		this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.RECETTE.FONCTIONNEMENT;
		this.typePiece = TYPE_PIECE.RECETTE.RECAP_AVEC_ROLE;
		this.imputation.nature = Nature.REEL;
		this.imputation.section = Section.FONCTIONNEMENT;
		this.panels = [
			...this.panels,
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new PeriodeCouvertePanel(),
			new RoleDeRecouvrementPanel(true),
		];
	}
}

export default ProfilEcritureTitreRecapRoleRecette;
